import React, { useState } from 'react';
import EditIcon from '../../assets/images/edit.svg';
import ProfileMainIcon from "../../assets/images/userImg.svg";
import { useSelector, useDispatch } from 'react-redux';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { uploadFile } from 'react-s3';
import { edituserDetailsUrl, getUserDetailsUrl } from '../../Routes/ApiRoutes.js';
import { Post, Get } from '../../Api/ApiMethods';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import {
  EmailValidation, 
  PhoneValidation, 
} from '../../utils/Validation.js';

export default function EditProfile() {
    const token = useSelector((state) => state.auth.isSignedIn);
    const userInfo = useSelector((state) => state.auth.adminData);
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();

    const [emailError, setEmailError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [addressError, setAddressError] = useState(null);
    const [imageError, setImageError] = useState(null);

    const [userData, setuserData] = useState({
        "image": userInfo.image,
        "phone": userInfo.phone,
        "email": userInfo.email,
        "address": userInfo.address,
        "country_code": userInfo.country_code ? userInfo.country_code : '+91'
    })

    const handleEmailsInput = (e) => {
        let updatedDetails = { ...userData };
        updatedDetails[e.target.id] = e.target.value;
        setuserData(updatedDetails)
   
        if(EmailValidation(e.target.value))
        {
           setEmailError(null);
        }
        else{
            setEmailError('Invalid email id.');
        }
    }
    
    const handlePhoneInput = (e) => {
        let updatedDetails = { ...userData };
        updatedDetails[e.target.id] = e.target.value;
        setuserData(updatedDetails)
        if(PhoneValidation(e.target.value))
        {
           setPhoneError(null);
        }
        else{
          setPhoneError('Invalid format of phone number.');
        }
    }

    const handleAddressInput = (e) => {
        let updatedDetails = { ...userData };
        updatedDetails[e.target.id] = e.target.value;
        setuserData(updatedDetails)
        if(e.target.value.length === 0){
            setAddressError('Address cannot be blank.')
        }else{
            setAddressError(null)
        }
    }

    const handleFileChange = (e) => {
        setLoader(true);
        if(e.target.files[0]){
            let imageArray = e.target.files[0].name.split('.');
			if(imageArray.length > 2  && imageArray.length < 2 )
			{
				setImageError("Double extension files are not allowed.");
                setLoader(false);
			}
            else if(imageArray[1] !== "jpeg" && imageArray[1] !== "jpg" && imageArray[1] !== "png" )
            {
                setLoader(false);
				setImageError("Only jpeg, jpg or png images are allowed.");
			}
            else if(e.target.files[0].length > 5242880)
            {
                setLoader(false);
				setImageError("Max size of profile image should be less than 5MB.");
            }
            else{
                let fl = e.target.files[0];
                let el = e.target.files[0].name.length;
                let nm = e.target.files[0].name;


                let config = {
                    'bucketName' : process.env.React_App_S3_bucketName,
                    'region' : process.env.React_App_S3_Region,
                    'accessKeyId' : process.env.React_App_S3_AccessKeyId,
                    'secretAccessKey' : process.env.React_App_S3_SecretAccessKey,
                    's3Url': process.env.React_App_S3_Url,
                };
                
                uploadFile(fl, config).then(d => {
                    document.getElementById('profileImg').src = d.location;
                    setLoader(false);
                    let updatedDetails = { ...userData };
                    updatedDetails['image'] = d.location;
                    setuserData(updatedDetails);
                    setImageError(null);
                    e.target.value = '';
                }).catch(err => {
                    setImageError(err.message);
                    setLoader(false);
                    e.target.value = '';
                })
            }
        }else{
            setImageError('Please select an image.');
            setLoader(false);
            e.target.value = '';
        }
    }

    const handelSavebtn = () => {
        setLoader(true);
        if(userData.email === '')
        {
            setLoader(false);
            setEmailError('Email id cannot be blank.')
        }
        if(userData.phone === '')
        {
            setLoader(false);
            setPhoneError('Phone cannot be blank.')
        }
        if(userData.address === '')
        {
            setLoader(false);
            setAddressError('Address cannot be blank.')
        }
        if(userData.email !== '' && userData.phone !== '' && userData.address !== '' && 
        !(phoneError) && !(emailError) && !(addressError)){     
            let send =  {
                "image": userData.image,
                "phone": userData.phone,
                "email": userData.email,
                "address": userData.address,
                "country_code": userData.country_code
            };
            
            if(userInfo.image === userData.image){
                delete send.image;
            }
            if(userInfo.phone === userData.phone){
                delete send.phone;
                delete send.country_code;
            }
            if(userInfo.email === userData.email){
                delete send.email;
            }
            if(userInfo.address === userData.address){
                delete send.address;
            }
            
            if(Object.keys(send).length > 0){
                try {
                    Post(edituserDetailsUrl, token, send)
                    .then(res => {
                        var msg = '';
                        toast.success(res.message);
                        if(userInfo.email !== userData.email && userInfo.phone !== userData.phone){
                            msg = 'both';

                            setTimeout(() => {
                                history.push({ 
                                pathname: '/verifyEm',
                                state : {...userData,  ...{message : msg}}
                                });
                                dispatch({
                                    type: 'SIGN_OUT',
                                });
                            }, 2100);
                        }else if(userInfo.email !== userData.email){
                            msg = 'only email';
                            
                            setTimeout(() => {
                                history.push({ 
                                pathname: '/verifyEm',
                                state : {...userData,  ...{message : msg}}
                                });
                                dispatch({
                                    type: 'SIGN_OUT',
                                });
                            }, 2100);
                        }else if(userInfo.phone !== userData.phone){
                            msg = 'only phone'
                            setTimeout(() => {
                                history.push({ 
                                pathname: '/verifyPh',
                                state : {...userData,  ...{message : msg}}
                                });
                                dispatch({
                                    type: 'SIGN_OUT',
                                });
                            }, 2100);
                        }else{
                            if (token) {
                                Get(getUserDetailsUrl, token)
                                    .then((res) => {
                                        if(res.status === 200){
                                            dispatch({
                                                type: 'ADMIN_DATA',
                                                payload: res.data.user,
                                            });
                                            setTimeout(() => history.push(`/profile`) ,2100);
                                        }   
                                    })
                                    .catch((error) => {
                                        toast.error(error.error);
                                        dispatch({
                                            type: 'SIGN_OUT',
                                        });
                                        setTimeout(() => history.push(`/login`) ,2100);
                                    });
                            }else{
                                dispatch({
                                    type: 'SIGN_OUT',
                                });
                                setTimeout(() => history.push(`/login`) ,2100);
                            }
                        }
                    })
                    .catch(error => {
                        toast.error(error.error);
                        setLoader(false);
                    })
                }catch (error) {
                    toast.error(error.error);
                    setLoader(false);
                }
            }else{
                toast.error('No changes identified !');
                setLoader(false);
            }
        }
    }


    return (
        <>
        {loader && <CircularLoader />}
            <section className="edit-profile-wrapper">
                <div className="container">
                    <div className="edit-profile">
                        <div className="row flexRowReverse no-gutters">
                            <div className="col-md-4 col-sm-12 col-12 padding-lt">
                                <div className="profile">
                                    <div className="user-Img-div">
                                        <img id='profileImg'  className="user-Img" src={userData.image ? userData.image : ProfileMainIcon} />
                                    </div>
                                    <div className="edit-btn">
                                        <button className='cursorP' onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('image').click();
                                            }}>Change image 
                                            <img className="ml-2" src={EditIcon} />
                                        </button>
                                        <input id='image' onChange={(e) => handleFileChange(e)} type='file' className='hidden'  />
                                        {imageError && <span className='form-error'>{imageError}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 col-sm-12 col-12 padding-rt">
                                <div className="generate">                
                                    <div className="form-group">
                                        <input id='name' defaultValue={userInfo.name} disabled type="text" className="form-control" placeholder="Name" />
                                    </div>   
                                    <div className="form-group">
                                        <input onChange={(e) => handlePhoneInput(e)} id='phone' value={userData.phone} 
                                        type="text" className={phoneError ? "form-control borderRed" : "form-control" } placeholder="Phone" />
                                        {phoneError && <span className='form-error'>{phoneError}</span>}                          
                                    </div>
                                    <div className="form-group">
                                        <input onChange={(e) => handleEmailsInput(e)} id='email' value={userData.email} 
                                        type="text" className={emailError ? "form-control borderRed" : "form-control" } placeholder="Email" />
                                        {emailError && <span className='form-error'>{emailError}</span>}
                                    </div> 
                                    <div className="form-group">
                                        <input onChange={(e) => handleAddressInput(e)} id='address' value={userData.address} 
                                        type="text" className={addressError ? "form-control borderRed" : "form-control" } placeholder="Address" />
                                        {addressError && <span className='form-error'>{addressError}</span>}
                                    </div> 
                                    {/* <div className="form-group">
                                        <input disabled id='dob' defaultValue='07 June 1990' type="text" className="form-control" placeholder="Date of birth" />
                                    </div>          */}
                                </div>
                            </div>
                        </div>
                        <div className=" comman-btn form-group">
                            <button onClick={() => handelSavebtn()}>Save</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
